/** zh-CN catalogue `rules` (W3-09; English: src/features/checker/rules/rules.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const EASE =
  '{easeKind, select, hold {钩定} bezier {自定义曲线 {easePoints}} other {{ease}{easeSlice, select, part {（{easeLeft} 到 {easeRight} 部分）} other {}}}}';
const PROP =
  '{prop, select, alpha {不透明度} moveX {X 位置} moveY {Y 位置} rotate {旋转} speed {流速} scaleX {X 尺寸} scaleY {Y 尺寸} color {颜色} text {文字} incline {倾斜} paint {画笔} gif {GIF 进度} other {某个属性}}';
const ELEMENT =
  '{element, select, pause {暂停按钮} combonumber {连击数} combo {连击标签} score {分数} bar {进度条} name {曲名} level {难度标签} other {HUD 元素}}';
const KIND = '{kind, select, tap { Tap } drag { Drag } flick { Flick } hold { Hold } other {音符}}';
const USE = '{use, select, image {判定线图片} audio {打击音} video {视频} shader {着色器} other {文件}}';

const catalog: MessageCatalog = {
  ns: 'rules',
  locale: 'zh-CN',
  messages: {
    fixAddMusic: '添加音乐文件…',
    fixAddPercentP: '改为“{text}”',
    fixAddThirdPoint: '添加第三个点',
    fixAddWhiteColour: '添加一个白色的颜色关键帧',
    fixChangeLineType: '更改判定线类型…',
    fixChooseFile: '选择文件…',
    fixChooseGif: '选择 GIF…',
    fixChooseMusic: '选择其他音乐文件…',
    fixClampHandles: '将控制柄限制在 0 到 1 之间',
    fixClampOpacity: '限制为 255',
    fixClampPreview: '限制在曲目范围内（{start} 到 {end}）',
    fixClampPreviewOpen: '限制在曲目范围内（从 {start} 开始）',
    fixConvertToPng: '转换为 PNG',
    fixConvertToTap: '转换为 Tap',
    fixConvertToWav: '转换为 WAV',
    fixDeleteDuplicate: '删除重复项',
    fixDeleteEffect: '删除特效',
    fixDownscale: '缩小到 {px} px',
    fixEditPreview: '编辑预览范围…',
    fixExtendHold: '延长为一个吸附步长',
    fixFlatten: '合并层级…',
    fixGoTo: '转到',
    fixGoToLine: '转到 {line}',
    fixGoToSpan: '转到该范围',
    fixHoldFirstValue: '保持第一个值',
    fixHoldVarFromStart: '从 {beat} 起保持第一个值',
    fixKeepTilt: '在整张谱面中保持 {deg}°',
    fixMakeIdentical: '使用曲线 {points}',
    fixMakeLinear: '改为线性',
    fixMoveNotesToNewLine: '将{count, plural, =1 {该音符} other {这 # 个音符}}移到新判定线',
    fixMoveTapLater: '将 Tap 后移一个吸附步长',
    fixNudgeCurve: '微调为 {points}',
    fixOpenSpeedSettings: '打开流速设置',
    fixPlainTail: '在最后一个关键帧之后显示“{text}”',
    fixReencodeGif: '以 {ms} 毫秒的帧时长重新编码',
    fixRemoveGifProgress: '移除 GIF 进度',
    fixRemoveIgnoredData: '移除被忽略的数据',
    fixRemoveReferences: '{count, plural, =1 {移除该引用} other {移除全部 # 处引用}}',
    fixRenameHitsound: '重命名为 {path}{count, plural, =0 {} other {，并让 # 个音符改为指向它}}',
    fixRenameTo: '重命名为 {path}',
    fixReplaceShader: '替换着色器文件…',
    fixResetRpeFields: '重置（Phira 中不变）',
    fixResetSlice: '使用整条曲线',
    fixSelectBoth: '选中两者',
    fixSelectNotes: '{count, plural, =1 {选中该音符} other {选中 # 个音符}}',
    fixSetOpacityFull: '将不透明度设为 100%',
    fixSetVarDefault: '将 {name} 设为 {value}',
    fixSnapTogether: '吸附到 {beat}',
    fixSnapX: '将 X 吸附到网格',
    fixUseEase: `使用${EASE}`,
    fixWriteInteger: '写为 {version}',
    ph01Title: '文件缺失或无法读取',
    ph01Missing: `项目中缺少${USE}“{path}”。`,
    ph01Undecodable: `${USE}“{path}”的格式 Phira 无法读取（{codec}）。`,
    ph01Why: '文件缺失或无法读取时，Phira 会拒绝加载谱面。此文件被使用了 {count, plural, other {# 次}}。',
    ph02Title: '音乐缺失或无法读取',
    ph02None: '谱面没有音乐文件。',
    ph02Missing: '项目中缺少音乐文件“{path}”。',
    ph02Undecodable: '音乐文件“{path}”的格式 Phira 无法读取（{codec}）。',
    ph02Why: '没有音乐时 Phira 无法播放谱面，也无法加载它。',
    ph03Title: '逐字显示或擦除文字的缓动超出范围',
    ph03What: `{line} 上位于 {beat} 的{case, select, reveal {逐字显示} other {擦除}}文字区段（“{from}”到“{to}”）使用了${EASE}，它会超出范围。`,
    ph03Why: 'Phira 会请求比文字多 {extra, plural, other {# 个字符}}，并在播放谱面时崩溃。',
    ph04Title: '帧延迟为零的 GIF',
    ph04What: 'GIF“{path}”的总帧延迟为 0 毫秒（{count, plural, other {被 # 条判定线使用}}）。',
    ph04Why: '将这样的 GIF 作为动态判定线加载时，Phira 会陷入无限循环，谱面永远不会开始。',
    ph05Title: 'Phira 会特殊处理的文件名',
    ph05Skin: '文件“{path}”以“click.png”结尾。',
    ph05SkinWhy: 'Phira 会把包含此类文件的谱面包当作音符皮肤，而不会将其作为谱面导入。',
    ph05Export: '谱面包中包含“{path}”。',
    ph05ExportWhy: 'Phira 会把包含 export.json 的谱面包当作批量导出，而不会将其作为谱面导入。',
    ph06Title: '1.7 流速模式下的贝塞尔流速',
    ph06What:
      '项目使用 1.7 流速曲线，但 {line} 上有{count, plural, other { # 个}}贝塞尔流速区段（第一个位于 {beat}）。',
    ph06Why: 'Phira 的 1.7 流速积分器无法计算贝塞尔流速，加载谱面时会崩溃。',
    ph07Title: 'Phira 会拒绝的特效变量',
    ph07Mismatch:
      '特效变量“{name}”写成了{given, select, null {空值（null，Phira 会将其读作数字）} float {数字} vec2 {数对 [x, y]} color {颜色 [r, g, b, a]} other {其他类型}}，但着色器需要{want, select, float {数字} vec2 {数对 [x, y]} color {颜色 [r, g, b, a]} other {其他类型}}。',
    ph07DefaultType: '着色器“{path}”为“{name}”设置了 {glslType} 类型的默认值；Phira 只接受 float、vec2 和 vec4。',
    ph07DefaultValue: '着色器“{path}”中“{name}”的默认值 Phira 无法读取。',
    ph07Why: 'Phira 会拒绝该特效，并导致整张谱面加载失败。',
    ph08Title: '使用会产生 NaN 的曲线的一部分',
    ph08What: `{owner, select, line {{line} 上${PROP}} effect {特效变量“{name}”} other {视频{which, select, alpha {不透明度} other {暗度}}}}位于 {beat} 的区段使用了${EASE}，并切割为 [{left}, {right}]，而该部分曲线两端高度相同。`,
    ph08Why: 'Phira 在那里会除以零：数值变为 NaN，在此区段内无法正确绘制。',
    ph09Title: '运动在第 0 拍之后才开始',
    ph09What: `{line} 的${PROP}{layer, plural, =0 {} other {（层级 #）}}从 {beat} 开始；在此之前 Phira 会向前延续第一个区段（0:0 处的值：{value}）。`,
    ph09Why: '判定线可能在谱面开头意外地移动、旋转或淡入淡出。',
    ph09WhyAlpha: '那里的不透明度低于 0，会在谱面开头隐藏判定线及其所有音符。',
    ph09WhyNaN: '那里的曲线会得到 NaN，因此判定线在谱面开头无法正确绘制。',
    ph10Title: '没有不透明度的判定线',
    ph10What: '{line} 没有不透明度关键帧，因此 Phira 会将其绘制为完全透明。',
    ph10WhyNotes: '其音符仍会显示，但判定线本身在 Phira 中不可见。',
    ph10WhyDecor: '它有运动，但没有音符也没有子线，看起来像是要被看到的装饰，但 Phira 不会显示它的任何内容。',
    ph10WhyContent:
      '其{kind, select, text {文字} texture {图片} gif {GIF} paint {画笔笔迹} other {内容}}在 Phira 中将不可见。',
    ph11Title: '没有不透明度的 UI 绑定线',
    ph11What: `UI 绑定线 {line} 移动${ELEMENT}，但没有不透明度关键帧。`,
    ph11Why: 'Phira 会让 HUD 元素使用其判定线的不透明度：没有不透明度关键帧时，该元素不可见。',
    ph12Title: 'UI 绑定线上的音符',
    ph12What: 'UI 绑定线 {line} 上有 {count, plural, other {# 个音符}}。',
    ph12Why: 'Phira 不会绘制 UI 绑定线上的音符，但仍会判定它们并播放打击音，因此玩家必须击打看不见的音符。',
    ph13Title: '音符速度为负',
    ph13What: '{line} 上有 {count, plural, other {# 个 Tap、Drag 或 Flick}}的速度为负（第一个位于 {beat}）。',
    ph13Why: '在 Phira 默认的音符剔除下，这些音符根本不会被绘制。对于从另一侧来的音符，请使用判定线的流速。',
    ph13WhyCullOff: '预览关闭了 Phira 的音符剔除，但大多数玩家会开着它，那时这些音符根本不会被绘制。',
    ph14Title: '带距离控制时速度为 0',
    ph14What: '{line} 有距离控制，而其上有 {count, plural, other {# 个音符}}的速度为 0（第一个位于 {beat}）。',
    ph14Why: 'Phira 通过除以速度来计算音符的距离：速度为 0 时距离为 NaN，距离控制会对这些音符使用其最后一个点。',
    ph15Title: '%P% 计数器按原文显示或显示为 0',
    ph15Tail: '{line} 的最后一个文字关键帧（{beat}）是“{text}”。',
    ph15TailWhy: '在最后一个关键帧之后，Phira 会显示原始文字，因此屏幕上会出现“%P%”。',
    ph15NotNumber: '{line} 上位于 {beat} 的计数器从“{from}”到“{to}”，但“{bad}”不是普通数字。',
    ph15NotNumberWhy: 'Phira 要求去掉 %P% 后的整段文字是一个数字，否则显示 0。请把标签放到单独的文字线上。',
    ph15OneSided: '{line} 上位于 {beat} 的文字区段只有一端包含 %P%（“{from}”到“{to}”）。',
    ph15OneSidedWhy: '只有两端都包含 %P% 时 Phira 才会计数；这里在下一个关键帧之前会显示“{shown}”。',
    ph16Title: '打字机文字的缓动超出范围',
    ph16What: `{line} 上位于 {beat} 的{case, select, extend {打字机} other {退格}}文字区段（“{from}”到“{to}”）使用了${EASE}，它会超出范围。`,
    ph16Why: 'Phira 会请求比文字多 {extra, plural, other {# 个字符}}；这可能使 Phira 崩溃（未验证）。',
    ph17Title: 'Phira 会忽略的距离控制',
    ph17What:
      '{line} 的{which, select, pos {位置} alpha {不透明度} size {尺寸} other {距离}}距离控制有两个点，从 1 开始且使用线性缓动。',
    ph17Why:
      'Phira 会完全忽略这样的曲线，但 RPE 会应用它，因此谱面在两者中看起来不同。添加第三个点可让 Phira 也应用它。',
    ph18Title: '带动画的音符倾斜',
    ph18What: '{line} 的音符倾斜随时间变化（0:0 处为 {from}°，在 {beat} 处变化）。',
    ph18Why: 'Phira 只在谱面开始时读取倾斜并一直保持：之后的变化没有效果。',
    ph19Title: '带缓动的流速被按直线播放',
    ph19What:
      '{line} 上有 {count, plural, other {# 个带缓动的流速区段}}（第一个位于 {beat}）在 Phira 中按直线渐变播放。',
    ph19Why: '项目使用经典流速模式，Phira 会忽略流速缓动；它们为 RPE 保留。切换到 1.7 流速曲线即可让 Phira 播放它们。',
    ph20Title: 'Phira 会合并的贝塞尔曲线',
    ph20What:
      '曲线为 {points} 的{count, plural, other { # 个}}贝塞尔区段与 {line} 上的曲线 {winner} 共用 Phira 取整后的缓存键。',
    ph20Why: 'Phira 对每个取整到 0.01 的缓存键只保留一条曲线，因此这些区段会以第一条曲线的形状播放。',
    ph21Title: '在 RPE 中看起来不同的缓动',
    ph21What: '{line} 上有 {count, plural, other {# 个区段}}（第一个位于 {beat}）使用了 InOutBack 或 InOutElastic。',
    ph21Why: 'Phira 对这两种缓动的实现与 RPE 不同，因此在 RPE 中打开谱面时运动看起来会不同。',
    ph22Title: 'Phira 会忽略的 RPE 判定线设置',
    ph22What:
      '{line} 有 Phira 会忽略的 RPE 设置：{fields, select, b {bpmfactor {bpmfactor}} a {anchor {anchor}} s {skewControl} ba {bpmfactor {bpmfactor} 和 anchor {anchor}} bs {bpmfactor {bpmfactor} 和 skewControl} as {anchor {anchor} 和 skewControl} other {bpmfactor {bpmfactor}、anchor {anchor} 和 skewControl}}。',
    ph22Why:
      'RPE 会使用它们（bpmfactor 改变判定线的速度，anchor 移动其图片，斜切控制让其音符倾斜），因此谱面在 RPE 和 Phira 中的播放效果不同。',
    ph23Title: '被负不透明度隐藏的音符',
    ph23What: '{line} 在 {beat} 附近的不透明度低于 0：有 {count, plural, other {# 个音符}}在被击打时是隐藏的。',
    ph23Why: 'Phira 会隐藏不透明度低于 0 的判定线上的所有音符，但仍会判定它们并播放打击音。',
    ph24Title: 'Phira 会忽略的判定线数据',
    ph24What:
      'Phira 会忽略 {line} 上的{item, select, text {文字} paint {画笔} gif {GIF 进度} other {数据}}，因为它是{kind, select, normal {普通判定线} texture {图片线} gif { GIF 线} text {文字线} paint {画笔线} other {判定线}}。',
    ph24WhyTextImage: 'Phira 只在没有图片的判定线上显示文字。',
    ph24WhyTextPaint: '带有画笔关键帧的判定线是画笔线，Phira 不会显示其文字。',
    ph24WhyPaintImage: 'Phira 只在没有图片的判定线上绘制画笔。',
    ph24WhyGifPlain: 'GIF 进度只适用于图片是 GIF 的判定线。',
    ph25Title: '超过 4 个层级',
    ph25What: `{line} 的${PROP}使用了 {count} 个层级。`,
    ph25Why: 'Phira 会播放每个层级，但 RPE 只显示前 4 个，因此其他层级在 RPE 中难以编辑。',
    ph26Title: '多条判定线移动同一个 HUD 元素',
    ph26What: `有 {count} 条判定线移动${ELEMENT}。`,
    ph26Why: 'Phira 只使用其中最后一条（{winner}）；其他判定线对 HUD 没有效果。',
    ph27Title: '非常大的判定线图片',
    ph27What: '判定线图片“{path}”为 {w} × {h} px。',
    ph27Why: 'Phira 绘制判定线图片时不使用 mipmap，因此非常大的图片在屏幕上缩小时会闪烁。',
    ph28Title: '画笔大小取决于屏幕',
    ph28What: '{line} 是画笔线。',
    ph28Why: 'Phira 以屏幕像素计量画笔，因此笔迹在大屏幕或高分辨率屏幕上看起来更细，在小屏幕上更粗。',
    ph29Title: '绑定的视频会被判定线颜色染色',
    ph29What: '视频“{path}”绑定到了没有颜色关键帧的 {line}。',
    ph29Why: 'Phira 会用判定线的颜色为绑定的视频染色；没有颜色关键帧时使用判定指示颜色（连击持续时为金色或蓝色）。',
    ph30Title: '特效变量在特效之后才开始',
    ph30What: '特效变量“{name}”从 {beat} 开始，晚于特效在 {start} 开始。',
    ph30Why: '在第一个关键帧之前，Phira 会向前延续第一个区段，因此特效开始时可能是意外的值。',
    ph31Title: '非 ASCII 文件名',
    ph31What: '文件名“{path}”包含 ASCII 以外的字符。',
    ph31Why: '压缩工具和 Phira 对此类文件名的解码方式可能不同，因此导出后可能找不到该文件。',
    ph32Title: 'Hold 中段不会被绘制',
    ph32What: '{line} 上有 {count, plural, other {# 个 Hold}}（第一个位于 {beat}）的尾部比头部更靠近判定线。',
    ph32Why: '在这些 Hold 期间音符会反向滚动，因此 Phira 只绘制其头部和尾部，不绘制中段。',
    ph33Title: '自定义着色器无法编译',
    ph33What: '自定义着色器“{path}”无法编译：{error}',
    ph33Why: 'Phira 会编译相同的 GLSL ES 1.00 代码，很可能会加载谱面失败。',
    ph34Title: 'RPEVersion 不是整数',
    ph34What: 'RPEVersion 写成了{kind, select, float {小数} other {文本}} {lexeme}，Phira 会将其读作 {effective}。',
    ph34Why:
      'Phira 会把小数形式的 RPEVersion 读作 160，而会解析文本形式的，这可能改变流速缓动的播放方式；使用整数可以避免意外。',
    ph35Title: '非 GIF 图片上的 GIF 进度',
    ph35What: '{line} 有{auto, select, yes {已开启的“自动播放”} other {GIF 进度关键帧}}，但其图片“{path}”不是 GIF。',
    ph35Why: 'Phira 会用 GIF 解码器读取这样的图片，并导致整张谱面加载失败。',
    ph36Title: '选曲预览超出音乐范围',
    ph36Negative: '选曲预览从 {start} 开始，早于音乐开始。',
    ph36Order: '选曲预览从 {start} 开始，却在更早的 {end} 结束。',
    ph36Beyond: '选曲预览在 {end} 结束，但音乐只有 {length} 长。',
    ph36BeyondNull: '选曲预览从 {start} 开始；Phira 会将 {end}（开始 + 1 秒）与音乐时长 {length} 进行比较。',
    ph36Why: '如果预览没有在音乐结束前至少 0.5 秒结束，Phira 会拒绝打开谱面；如果预览的开始晚于结束，Phira 会崩溃。',
    ph36WhyShort: 'Phira 会拒绝打开谱面，而音乐太短，没有任何在音乐结束前 0.5 秒结束的预览范围。',
    ph37Title: '零长度的 Hold',
    ph37What: '{line} 上位于 {beat} 的 Hold 没有长度。',
    ph37Why: 'Phira 会像 Tap 一样判定它，并只显示一瞬间。',
    ph38Title: '使用保留名称的打击音文件',
    ph38What: '谱面包中包含名为“{path}”的文件{count, plural, =0 {。} other {（有 # 个音符使用该名称）。}}',
    ph38Why: '对打击音为“{path}”的音符，Phira 会播放其内置音效，而永远不会使用此文件。',
    ph39Title: '贝塞尔控制柄超出 0 到 1',
    ph39What: `{line} 上位于 {beat} 的${PROP}的贝塞尔曲线 {points} 有一个控制柄的 x 超出了 0 到 1。`,
    ph39Why: 'Phira 能播放它，但 RPE 的曲线编辑器可能无法显示或保留它。',
    gp01Title: '紧接在附近 Flick 之后的 Tap',
    gp01What: '此 Tap 位于一个距离 {px} px 的 Flick 之后 {ms} 毫秒（粉接八）。',
    gp01Why: '划过 Flick 的玩家会提前击中此 Tap，判定为 Good。',
    gp02Title: '紧接在附近 Drag 之后的 Tap',
    gp02What: '此 Tap 位于一个距离 {px} px 的 Drag 之后 {ms} 毫秒。',
    gp02Why: '玩家会用一次触摸同时击中 Drag 和此 Tap，因此 Tap 会被判定为过早。',
    gp02WhyLater: '手指一直停在 Drag 上的玩家必须非常快地抬起并再次触摸，才能击中此 Tap。',
    gp03Title: '重叠的音符',
    gp03What:
      '位于 {beat} 的{pair, select, taptap {两个 Tap} taphold {一个 Tap 和一个 Hold} holdhold {两个 Hold} other {两个音符}}只相距 {px} px。',
    gp03Why: '一次触摸只能击中其中一个，因此玩家需要用两根手指按同一个位置。',
    gp04Title: '曲目范围外的音符',
    gp04Before: '{line} 上有 {count, plural, other {# 个音符}}在音乐开始之前（第一个位于 {beat}）。',
    gp04BeforeWhy: '偏移为 {offset} 毫秒时，这些音符落在音乐开始之前，玩家无法跟着曲目按时击打。',
    gp04After: '{line} 上有 {count, plural, other {# 个音符}}在音乐结束之后才结束（第一个位于 {beat}）。',
    gp04AfterWhy: '那时音乐已经结束，这些音符会在寂静中出现，Phira 也可能在玩家到达之前结束谱面。',
    gp05Title: '在屏幕外被击打的音符',
    gp05What: '{line} 上有 {count, plural, other {# 个音符}}在屏幕外的位置被击打（第一个位于 {beat}）。',
    gp05WhyReachable: '玩家只能在屏幕上与音符对齐的某处触摸来击中它们，却看不到具体位置。',
    gp05WhyUnreachable: '其中有 {count, plural, other {# 个}}完全无法从屏幕上触及，因此玩家总会 Miss。',
    gp06Title: '读谱时间过短',
    gp06What:
      '{line} 上位于 {beat} 的{count, plural, =1 {这个{kind, select, tap { Tap } drag { Drag } flick { Flick } hold { Hold } other {音符}}} other { # 个{kind, select, tap { Tap } drag { Drag } flick { Flick } hold { Hold } other {音符}}}}在被击打前只可见 {ms} 毫秒。',
    gp06Never:
      '{line} 上位于 {beat} 的{count, plural, =1 {这个{kind, select, tap { Tap } drag { Drag } flick { Flick } hold { Hold } other {音符}}} other { # 个{kind, select, tap { Tap } drag { Drag } flick { Flick } hold { Hold } other {音符}}}}在被击打前不可见。',
    gp06Why: '玩家大约需要 {min} 毫秒来读一个音符。按当前皮肤和 Phira 设置，在 {w} × {h} 的屏幕上测量。',
    gp07Title: 'Hold 与其他音符相碰',
    gp07Start: `位于 {beat} 的一个${KIND}与一个 Hold 的开头相碰（相距 {px} px）。`,
    gp07StartWhy: '一次触摸会开始 Hold，也可能同时击中这个音符，或者玩家无法分辨两者。',
    gp07End: `位于 {beat} 的一个${KIND}与一个 Hold 的结尾相碰（相距 {px} px）。`,
    gp07EndWhy: '仍在按住的玩家必须在那一刻抬起并再次触摸同一位置，很容易失误。',
    gp08Title: '离判定线中心太远的音符',
    gp08What: '{line} 上有 {count, plural, other {# 个音符}}距离判定线中心超过 {max} px（第一个位于 {beat}，X {x}）。',
    gp08Why: '这么远的音符在未移动的判定线上位于或超出屏幕边缘，难以看到和触及。',
    gp08WhyFake: '这些假键在未移动的判定线上位于或超出屏幕边缘，玩家可能看不到它们。',
    gp09Title: '几乎同时的音符',
    gp09What: '位于 {beat} 的两个音符相差 {ms} 毫秒，而不是完全同时。',
    gp09Why: '只有时间完全相等时 Phira 才会将音符高亮为多押，因此这些音符显示时没有高亮。',
    gp10Title: '不透明度高于 255',
    gp10What: '{line} 上有 {count, plural, other {# 个不透明度关键帧}}高于 255（第一个位于 {beat}：{value}）。',
    gp10Why: '高于 255 的不透明度看起来与 255 相同，因此淡出会显得开始得晚。用于隐藏音符的低于 0 的值没有问题。',
    gp10WhatSum:
      '{line} 的 {layers} 个不透明度层级相加后在 {count, plural, other {# 个关键帧}}处超过 255（第一个位于 {beat}：{value}）。',
    gp10WhySum:
      'Phira 绘制的是各层级之和，而高于 255 的和看起来与 255 相同，因此淡出会显得开始得晚。用于隐藏音符的低于 0 的和没有问题。',
  },
};

export default catalog;
